import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '../services/api'

interface AdminUser {
  id: string
  email: string
  last_login_at: string | null
}

export const useAuthStore = defineStore('auth', () => {
  const admin = ref<AdminUser | null>(null)
  const isAuthenticated = computed(() => !!admin.value)

  async function checkAuth() {
    try {
      const { data } = await api.get('/auth/me', { _skipAuthRedirect: true } as any)
      admin.value = data
    } catch {
      admin.value = null
    }
  }

  async function login(email: string, password: string) {
    const { data } = await api.post('/auth/login', { email, password })
    admin.value = data
  }

  async function logout() {
    try {
      await api.post('/auth/logout')
    } finally {
      admin.value = null
    }
  }

  return { admin, isAuthenticated, checkAuth, login, logout }
})
